module.exports = __webpack_public_path__ + "img/Flaticon2.e1e2b6e0.svg";